<template>
    <group-details :groupId="props.groupId">
        <snippet-list :groupId="props.groupId" readOnly withoutOverview embedded></snippet-list>
    </group-details>
</template>

<script setup>
import GroupDetails from './GroupDetails.vue';
import SnippetList from '~/components/snippets/SnippetList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: false,
    },
});

</script>
